module.exports = __webpack_public_path__ + "static/media/Floorplan.ed6ed1b0.svg";